/** Hyvo's mark: one dot of the crowd, part full. */
export function Logomark({ size = 20 }: { size?: number }) {
  return (
    <svg viewBox="0 0 20 20" width={size} height={size} aria-hidden="true">
      <circle cx="10" cy="10" r="8.75" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2.2 11.5a8 8 0 0 0 15.6 0Z" fill="currentColor" />
    </svg>
  );
}

/** One small mark per kind of trader, so a feed reads at a glance without more color. */
export function PersonaIcon({ persona, size = 14 }: { persona: string; size?: number }) {
  const common = {
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  } as const;
  switch (persona) {
    case "sniper":
      return (
        <svg {...common}>
          <circle cx="8" cy="8" r="4.4" />
          <path d="M8 1.2v3.2M8 11.6v3.2M1.2 8h3.2M11.6 8h3.2" />
        </svg>
      );
    case "holder":
      return (
        <svg {...common}>
          <path d="M4.6 2.6h6.8L14.4 6.4 8 13.8 1.6 6.4Z" />
          <path d="M1.6 6.4h12.8" />
        </svg>
      );
    case "panic_seller":
      return (
        <svg {...common}>
          <path d="M9.2 1.4 3.4 9h4.1l-.9 5.6L12.6 7H8.4Z" />
        </svg>
      );
    case "skeptic":
      return (
        <svg {...common}>
          <path d="M1.4 8s2.5-4.6 6.6-4.6S14.6 8 14.6 8s-2.5 4.6-6.6 4.6S1.4 8 1.4 8Z" />
          <circle cx="8" cy="8" r="1.9" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="8" cy="8" r="5" />
        </svg>
      );
  }
}

export function Arrow() {
  return (
    <svg className="arrow" viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2.500 8h11M9 3.500 13.500 8 9 12.500" />
    </svg>
  );
}

export function CheckMark({ size = 14 }: { size?: number }) {
  return (
    <svg viewBox="0 0 16 16" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 8.600 6.400 12 13 4.600" pathLength={1} className="draw" />
    </svg>
  );
}
